import { GetFromStorage } from '@/vessi.utils';

// initial state	
export default () => ({
	version: undefined,
	loading: false,
	lastCall: undefined,
	error: undefined,
})